import Vue from 'vue'
import VueTypes from 'vue-types'
import AccountType from '@/constants/user/AccountType'
import { ACCOUNT_TYPES, AccountTypes } from '@/constants/user/accountTypes'
import Avatar from '@/models-ts/user/Avatar'

const SIZES = [40, 80, 180, 360]

interface Computed {
  accountType: AccountType
  hasAvatar: boolean
  defaultSrc: string
  defaultSrcSet: string
  src: string
  srcset: Array<String>
  srcSizes: string
  isSmall: boolean
}

interface Props {
  avatar: Avatar
  loading: boolean
  userId: number
  userType: AccountTypes
  sizes: String
  defaultUrlSize: (typeof SIZES)[number]
  imgAttrs: {}
}

export default Vue.extend<{}, {}, Computed, Props>({
  name: 'lx-avatar',
  props: {
    avatar: Avatar,
    loading: Boolean,
    userId: {
      type: Number,
      required: true,
    },
    userType: {
      validator: (v) => ACCOUNT_TYPES.includes(+v),
    },
    sizes: String,
    defaultUrlSize: VueTypes.oneOf(SIZES).def(40),
    imgAttrs: VueTypes.object.def({}),
  },
  computed: {
    accountType() {
      return AccountType.getType(this.userType)
    },
    hasAvatar() {
      return this.avatar?.src
    },
    defaultSrc() {
      return `/static/images/avatars/user-${(this.userId || 0) % 6}-${this.defaultUrlSize}.png`
    },
    defaultSrcSet() {
      return SIZES.map((size) => `/static/images/avatars/user-${(this.userId || 0) % 6}-${size}.png ${size}w`).join(', ')
    },
    src() {
      return this.hasAvatar ? this.avatar.src : this.defaultSrc
    },
    srcset() {
      return this.hasAvatar ? this.avatar.srcSet : this.defaultSrcSet
    },
    srcSizes() {
      return this.sizes || `${this.defaultUrlSize}px`
    },
    isSmall() {
      return Number.parseInt(this.srcSizes) < 64
    },
  },
})
